import { Check, AlertTriangle, MinusCircle, OctagonX, X } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { PhotoUpload } from "@/components/fleet/Photos";
import { DEFAULT_STOP } from "@/components/fleet/ChecklistEditor";

const OPTIONS = {
  check: [["ok", "OK", Check, "border-emerald-500 bg-emerald-500/15 text-emerald-300"], ["fault", "Fault", AlertTriangle, "border-red-500 bg-red-500/15 text-red-300"], ["not_done", "Not done", MinusCircle, "border-zinc-400 bg-zinc-500/20 text-zinc-200"]],
  question: [["yes", "Yes", Check, "border-emerald-500 bg-emerald-500/15 text-emerald-300"], ["no", "No", X, "border-red-500 bg-red-500/15 text-red-300"]],
};

export const isStop = (item, value, stage) => stage === "pre" && item.stop_ride && ["fault", "no"].includes(value?.answer);

export const CheckItem = ({ item, value = {}, onChange, stage }) => {
  const set = (p) => onChange({ note: "", photos: [], ...value, ...p });
  if (item.kind === "text") {
    return (
      <div data-testid={`check-${item.id}`} className="space-y-2 border-b px-4 py-4 last:border-0 sm:px-5">
        <div className="flex items-start justify-between gap-3">
          <span className="text-sm font-semibold">{item.label}</span>
          {item.mandatory && <span className="shrink-0 rounded bg-primary/15 px-1.5 py-0.5 text-[10px] font-bold uppercase text-primary">Required</span>}
        </div>
        <Textarea rows={2} value={value.note || ""} onChange={(e) => set({ answer: "text", note: e.target.value })} data-testid={`text-${item.id}`} />
      </div>
    );
  }
  const opts = OPTIONS[item.kind] || OPTIONS.check;
  const issue = ["fault", "no"].includes(value.answer);
  return (
    <div data-testid={`check-${item.id}`} className={`space-y-3 border-b px-4 py-4 last:border-0 sm:px-5 ${issue ? "bg-red-500/5" : ""}`}>
      <div className="flex items-start justify-between gap-3">
        <span className="text-sm font-semibold">{item.label}</span>
        <span className="flex shrink-0 gap-1">
          {item.stop_ride && stage === "pre" && <span className="rounded bg-red-500/20 px-1.5 py-0.5 text-[10px] font-bold uppercase text-red-300">Safety critical</span>}
          {item.mandatory && <span className="rounded bg-primary/15 px-1.5 py-0.5 text-[10px] font-bold uppercase text-primary">Required</span>}
        </span>
      </div>
      <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${opts.length}, minmax(0, 1fr))` }}>
        {opts.map(([k, label, Icon, active]) => {
          const disabled = k === "not_done" && item.mandatory;
          return (
            <button key={k} type="button" disabled={disabled} onClick={() => set({ answer: k })} data-testid={`answer-${item.id}-${k}`}
              className={`flex min-h-[46px] items-center justify-center gap-1.5 rounded-xl border-2 text-xs font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-30 ${value.answer === k ? active : "border-border text-muted-foreground hover:border-zinc-500"}`}>
              <Icon className="h-4 w-4" /> {label}
            </button>
          );
        })}
      </div>
      {isStop(item, value, stage) && (
        <div data-testid={`stop-msg-${item.id}`} className="flex items-start gap-2 rounded-xl border-2 border-red-500 bg-red-600/20 px-3 py-2.5 text-sm font-bold text-red-100">
          <OctagonX className="mt-0.5 h-5 w-5 shrink-0 text-red-400" /> {item.stop_message || DEFAULT_STOP}
        </div>
      )}
      {issue && (
        <div className="space-y-2">
          <Textarea rows={2} placeholder="Describe the fault, damage or missing item (required)" value={value.note || ""} onChange={(e) => set({ note: e.target.value })} data-testid={`note-${item.id}`} />
          <PhotoUpload photos={value.photos || []} onChange={(photos) => set({ photos })} testId={`photo-input-${item.id}`} />
        </div>
      )}
    </div>
  );
};
